import { render, staticRenderFns } from "./DeOutWidget.vue?vue&type=template&id=670963d4&scoped=true&"
import script from "./DeOutWidget.vue?vue&type=script&lang=js&"
export * from "./DeOutWidget.vue?vue&type=script&lang=js&"
import style0 from "./DeOutWidget.vue?vue&type=style&index=0&id=670963d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670963d4",
  null
  
)

export default component.exports